import * as React from 'react';
import { Tooltip } from '@cian/ui-kit/tooltip';

import * as styles from './PlatformsLink.css';
import { plural } from '@cian/utils';

export interface IPlatformsLinkProps {
  platforms: string[];
}

export function PlatformsLink({ platforms }: IPlatformsLinkProps) {
  const tooltipTitle = <div className={styles['popup-text']}>{platforms.join(', ')}</div>;

  /* istanbul ignore next */
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
  };

  return (
    <Tooltip title={tooltipTitle} theme="white" placement="right">
      <a data-testid="platforms-link" className={styles['dashed']} href="#" onClick={handleClick}>
        {`${platforms.length} ${plural(platforms.length, ['площадке', 'площадках', 'площадках'])}`}
      </a>
    </Tooltip>
  );
}
